import React, { createContext, useState, useEffect, useMemo } from 'react';

// Create a context for theme
export const ThemeContext = createContext({
  mode: 'light',
  toggleTheme: () => {},
  setMode: () => {}, // Add setMode to context
});

// Theme provider component
export const ThemeProvider = ({ children }) => {
  // Check if system prefers dark mode
  const prefersDarkMode = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
  // Initialize theme mode from localStorage or system preference
  const [mode, setMode] = useState(() => {
    const savedMode = localStorage.getItem('themeMode');
    return savedMode || 'dark'; // Default to dark mode
  });

  // Effect to save theme mode to localStorage when it changes
  useEffect(() => {
    localStorage.setItem('themeMode', mode);
  }, [mode]);

  // Toggle theme function
  const toggleTheme = () => {
    setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
  };

  // Memoize the context value to prevent unnecessary re-renders
  const themeContextValue = useMemo(
    () => ({
      mode,
      toggleTheme,
      setMode, // Provide setMode in context
    }),
    [mode]
  );

  return (
    <ThemeContext.Provider value={themeContextValue}>
      {children}
    </ThemeContext.Provider>
  );
};
